import { observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import Loader from 'react-loader-spinner';
import BillingAddressForm from './billingAddressForm';
import ShippingAddressForm from './shippingAddressForm';
import AgreementModal from '../voucherpage/agreementModal';

const CartBillingAddress = observer(
  ({ cartStore, settingsStore }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const billingFormRef = useRef();
    const [model, setModel] = useState(false);
    const [tempData, setTempData] = useState([]);
    const { t } = useTranslation();

    const getData = (title, content) => {
      setTempData([title, content]);
      setModel(true);
    };

    const handleCheckAndPay = () => {
      // Ensure that the billing form is validated before proceeding
      const isBillingValid = billingFormRef.current?.validate();
      if (!isBillingValid) return;

      cartStore.handlePayment();
    };

    return (
      <div style={{ marginTop: '30px' }}>
        {/* Billing Address Form */}
        <BillingAddressForm
          cartStore={cartStore}
          ref={billingFormRef}
        />

        {/* Shipping Address Option */}
        {cartStore.requiresShipping && (
          <div style={{ width: '100%', marginTop: '10px' }}>
            <input
              type="checkbox"
              id="reqshp"
              onClick={() => cartStore.updateUseForShipping()}
            />
            <label htmlFor="reqshp">
              {t('DIFFERENT_DELIVERY_ADDRESS')}
            </label>
          </div>
        )}

        {/* Shipping Address Form */}
        {!cartStore.useForShipping && (
          <ShippingAddressForm cartStore={cartStore} />
        )}

        {/* Agreements Section */}
        {cartStore.requiresAgreements ? (
          <div style={{ width: '100%', marginTop: '15px' }}>
            {cartStore.agreementData.map((agreement, index) => (
              <div
                key={`agreement-${index}`}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <input
                  type="checkbox"
                  id={`agreement-${index}`}
                  checked={
                    cartStore.agreementsChecked[index] || false
                  }
                  onChange={(e) =>
                    cartStore.setAgreementsChecked(
                      index,
                      e.target.checked,
                    )
                  }
                />
                <label
                  htmlFor={`agreement-${index}`}
                  style={{ textDecoration: 'underline' }}
                >
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      getData(agreement.title, agreement.content);
                    }}
                  >
                    {agreement.title}
                  </a>
                </label>
              </div>
            ))}

            {model && (
              <AgreementModal
                title={tempData[0]}
                content={tempData[1]}
                hide={() => setModel(false)}
              />
            )}
          </div>
        ) : (
          <div style={{ marginTop: '15px' }}>
            {t('CONFIRM_BY_CLICKING_ON_CHECK_AND_PAY_BUTTON')}{' '}
            {cartStore.agreementData.map((agreement, index) => (
              <span key={`agreement-text-${index}`}>
                {agreement.title}
                {index !== cartStore.agreementData.length - 1 && ', '}
              </span>
            ))}
            .
          </div>
        )}

        {/* Checkout Button */}
        <button
          style={{ marginBottom: '20px', width: '100%' }}
          disabled={cartStore.paymentLoading}
          onClick={handleCheckAndPay}
        >
          {!cartStore.paymentLoading ? (
            t('CHECK_AND_PAY')
          ) : (
            <Loader width={30} height={30} type="Circles" />
          )}
        </button>
      </div>
    );
  },
);

export default CartBillingAddress;
